module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/map/direction-2-d30dd4ca77563b6848bc0ee309e25292.svg";